import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SummaryFlowViewComponent } from '../../summary-flow-view/summary-flow-view.component';
import { DefaultDisplayComponent } from "../default-display/default-display.component";

@Component({
    selector: 'query-button-display',
    templateUrl: './query-button-display.component.html',
    styleUrls: ['./query-button-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class QueryButtonDisplayComponent extends DefaultDisplayComponent implements OnInit {

    get displayValue(): string {
        if (this.value === Object(this.value)) {
            return "Table results cannot be displayed in Summary";
        }
        return this.value;
    }

    constructor() { super(); }

    ngOnInit() {
        super.ngOnInit();
    }
}
